import { render, staticRenderFns } from "./ScrollableView.vue?vue&type=template&id=0b853486"
import script from "./ScrollableView.vue?vue&type=script&lang=js"
export * from "./ScrollableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports